module.exports = __webpack_public_path__ + "abf5a00e556c4039c252745802349171.svg";